interface ILoadScript {
    src: string,
    id?: string,
    onLoad?: () => void,
    onError?: OnErrorEventHandler
}

type TLoadScript = (LoadScriptProps: ILoadScript) => HTMLScriptElement;

const loadScript: TLoadScript = ({src, id, onLoad, onError}) => {
    const $element = !!id
        ? document.querySelector(`#${id}`)
        : document.querySelector(`script[src="${src}"]`);
    
    if (!!$element) {
        return $element as HTMLScriptElement;
    }
    
    const script = document.createElement('script') as HTMLScriptElement;
    script.type = 'text/javascript';
    
    if (id) {
        script.id = id;
    }
    
    if (onLoad) {
        script.onload = onLoad;
    }
    
    if (onError) {
        script.onerror = onError;
    }
    
    script.src = src;

    return document.getElementsByTagName('head')[0].appendChild(script);
};

export default loadScript;